module.exports = __webpack_public_path__ + "static/img/no-search.a6290ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/queshengye/no-search.png
// module id = g/az
// module chunks = 17